import './tabs'
import './disponibility-table'
import './featured-posts'
import './featured-programs'
import './slider-programs'
import './program-contact-form'
import './metropole'
import './navigation'
import './login-form'
import './key-steps'
import './choice-search'